import { Routes } from '@angular/router';
import { CurrentUserComponent } from './components/current-user/current-user.component';
import { LayoutComponent } from './components/layout/layout.component';
import { SigninRedirectCallbackComponent } from './components/signin-redirect-callback/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './components/signout-redirect-callback/signout-redirect-callback.component';
import { HomeComponent } from './home/home.component';
import { OrganizationsComponent } from './pages/organizations/organizations.component';
import { SessionComponent } from './pages/session/session.component';
import { SessionsComponent } from './pages/sessions/sessions.component';
import { TeamsComponent } from './pages/teams/teams.component';
import { TripComponent } from './pages/trip/trip.component';
import { UsersComponent } from './pages/users/users.component';
import { DatePipe } from '@angular/common';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: HomeComponent, },
      { path: 'currentuser', component: CurrentUserComponent },
      { path: 'organizations', component: OrganizationsComponent },
      {
        path: 'sessions',
        children: [
          { path: '', component: SessionsComponent },
          {
            path: 'session',
            children: [
              { path: '', component: SessionComponent },
              {
                path: 'trip', component: TripComponent,
                providers: [DatePipe]
 }
            ]
          }
        ]
      },
      { path: 'teams', component: TeamsComponent },
      { path: 'users', component: UsersComponent }
    ]
  },
  { path: 'signin-callback', component: SigninRedirectCallbackComponent },
  { path: 'signout-callback', component: SignoutRedirectCallbackComponent }
];
